/* global  */ // tUrl等のグローバル変数を宣言する
import scrollLock from './functions/_scrollLock.js' // スクロールロック

import autoScroll from './functions/_autoScroll.js' // 自動スクロール

import 'core-js/features/number/is-nan' // SwiperのIE対応
import 'custom-event-polyfill' // SwiperのIE対応
import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

if (!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector
}

if (!Element.prototype.closest) {
  Element.prototype.closest = function (s) {
    var el = this

    do {
      if (Element.prototype.matches.call(el, s)) return el
      el = el.parentElement || el.parentNode
    } while (el !== null && el.nodeType === 1)
    return null
  }
}

/*
 ######  ##       #### ########  ########
##    ## ##        ##  ##     ## ##
##       ##        ##  ##     ## ##
 ######  ##        ##  ##     ## ######
      ## ##        ##  ##     ## ##
##    ## ##        ##  ##     ## ##
 ######  ######## #### ########  ########
*/

/*
        ##     ## ##     ##
        ###   ### ##     ##
        #### #### ##     ##
####### ## ### ## ##     ##
        ##     ##  ##   ##
        ##     ##   ## ##
        ##     ##    ###
*/

if (document.getElementById('topMv')) {
  // Swiperコンテナを検出したら実行
  // eslint-disable-next-line no-unused-vars
  const slideItem = document.getElementById('topMv')
  const topMvSwiper = new Swiper(slideItem, {
    // init: false, // 自動で初期化しない（topMvSwiper.init()で初期化）
    effect: 'fade', // slide,fade,cube,coverflow
    speed: 1000, // アニメ速度
    loop: true, // ループ
    preloadImages: false, // スライド内の画像を読み終えてから開
    fadeEffect: {
      // フェードオプション
      // crossFade: true, // クロスフェード
    },
    autoplay: {
      // オートオプション
      delay: 5000, // 待機時間
      disableOnInteraction: false, // 操作されたらオート解除
    },
  })

  // マウスホバーでスライドを操作する
  window.addEventListener('mouseover', function (e) {
    if (!e.target.classList.contains('js-hoverSlide')) {
      return
    }
    const slideNo = e.target.dataset.slide
    topMvSwiper.slideTo(slideNo) // 指定番号のスライドへ
    topMvSwiper.autoplay.stop() // 自動再生を停止
  })
  window.addEventListener('mouseout', function (e) {
    if (!e.target.classList.contains('js-hoverSlide')) {
      return
    }
    topMvSwiper.autoplay.start() // 自動再生を再開
  })
}

/*
         ##    ## ######## ##      ##
         ###   ## ##       ##  ##  ##
         ####  ## ##       ##  ##  ##
 ####### ## ## ## ######   ##  ##  ##
         ##  #### ##       ##  ##  ##
         ##   ### ##       ##  ##  ##
         ##    ## ########  ###  ###
*/

if (document.getElementById('newProduct')) {
  // Swiperコンテナを検出したら実行

  const slideItem = document.getElementById('newProduct')

  const sliderValue = slideItem.dataset.sliderValue // スライド枚数
  const sliderBorder = 3 // 本来想定する最低スライド枚数

  // 指定枚数以上かどうかで分岐させる
  const isSliderBorderOver = sliderValue >= sliderBorder
  const slideLoop = isSliderBorderOver // ループ

  // 自動スライド
  const slideAuto = isSliderBorderOver
    ? {
        delay: 7000, // 待機時間
        disableOnInteraction: false, // 操作されたらオート解除
      }
    : false

  const wideCenter = isSliderBorderOver // 表示領域が広い際のセンタリング

  const sliderName = 'newProduct'
  // eslint-disable-next-line no-unused-vars
  const newProductSwiper = new Swiper(slideItem, {
    effect: 'slide', // slide,fade,cube,coverflow
    speed: 500, // アニメ速度
    loop: slideLoop, // ループ
    preloadImages: false, // スライド内の画像を読み終えてから開始
    // grabCursor: true, // 掴みカーソル
    // simulateTouch: false, // マウスドラッグでスワイプ操作　無効でテキスト選択が可能に

    autoplay: slideAuto,

    navigation: {
      nextEl: '.swiper-button-next--' + sliderName, // 前のページボタンを呼び出す要素
      prevEl: '.swiper-button-prev--' + sliderName, // 次のページボタンを呼び出す要素
    },

    breakpoints: {
      // 指定px以上でオプション切り替え
      1080: {
        slidesPerView: 2, //表示数変更
        spaceBetween: 20, //スライド同士の間隔を空ける
      },
      1200: {
        slidesPerView: 3, //表示数変更
        spaceBetween: 20, //スライド同士の間隔を空ける
        centeredSlides: wideCenter, // 中央のスライドを基準にする
      },
    },
  })
}

/*
          ######  ##     ## ########
         ##    ## ##     ## ##     ##
         ##       ##     ## ##     ##
 #######  ######  ##     ## ########
               ## ##     ## ##
         ##    ## ##     ## ##
          ######   #######  ##
*/

if ($('.js-top-support-slide')[0]) {
  // eslint-disable-next-line no-unused-vars
  const topSupportSwiper = new Swiper('.js-top-support-slide', {
    speed: 400,
    loop: true,
    autoplay: {
      delay: 5000,
    },
    pagination: {
      el: '.js-top-support-pagenation',
      type: 'bullets',
      clickable: true,
    },
  })
}
if ($('.js-top-casestudy-slide')[0]) {
  var topStudySwiper
  let w = $(window).width()
  if (w <= 840) {
    if (topStudySwiper) {
      // return
    } else {
      createStudySwiper(topStudySwiper)
    }
  } else {
    if (topStudySwiper) {
      topStudySwiper.destroy()
      topStudySwiper = undefined
    }
  }
  $(window).on('load resize ', function () {
    w = $(window).width()
    if (w <= 840) {
      if (topStudySwiper) {
        // return
      } else {
        createStudySwiper(topStudySwiper)
      }
    } else {
      if (topStudySwiper) {
        topStudySwiper.destroy()
        topStudySwiper = undefined
      }
    }
  })
}
function createStudySwiper(topStudySwiper) {
  topStudySwiper = new Swiper('.js-top-casestudy-slide', {
    speed: 400,
    slidesPerView: 1.5,
    spaceBetween: 30,
    centeredSlides: true,
    loop: true,
  })
}

/*
        ########  ########   #######
        ##     ## ##     ## ##     ##
        ##     ## ##     ## ##     ##
####### ########  ########  ##     ##
        ##        ##   ##   ##     ##
        ##        ##    ##  ##     ##
        ##        ##     ##  #######
*/

if (document.getElementById('productImage')) {
  // Swiperコンテナを検出したら実行
  // eslint-disable-next-line no-unused-vars
  const slideItem = document.getElementById('productImage')
  const productImageSwiper = new Swiper(slideItem, {
    // init: false, // 自動で初期化しない（productImageSwiper.init()で初期化）
    effect: 'fade', // slide,fade,cube,coverflow
    speed: 500, // アニメ速度
    autoHeight: true, // スライドごとに高さを変動させる
    preloadImages: false, // スライド内の画像を読み終えてから開始
    simulateTouch: false, // マウスドラッグでスワイプ操作　無効でテキスト選択が可能に
    touchRatio: 0, // タッチスワイプ感度（0でタッチスワイプ無効）
    fadeEffect: {
      // フェードオプション
      crossFade: true, // クロスフェード
    },
  })

  // ボタンでスライドを操作する
  const slideBtnList = document.getElementsByClassName('js-slideMove')
  window.addEventListener('click', function (e) {
    if (!e.target.classList.contains('js-slideMove')) {
      return
    }
    for (let index = 0; index < slideBtnList.length; index++) {
      slideBtnList[index].classList.remove('active')
    }
    e.target.classList.add('active')
    productImageSwiper.slideTo(e.target.dataset.slide)
  })
}

/*
            ###    ########   #######  ##     ## ########
           ## ##   ##     ## ##     ## ##     ##    ##
          ##   ##  ##     ## ##     ## ##     ##    ##
 ####### ##     ## ########  ##     ## ##     ##    ##
         ######### ##     ## ##     ## ##     ##    ##
         ##     ## ##     ## ##     ## ##     ##    ##
         ##     ## ########   #######   #######     ##
*/

let companyAboutSwiper
if (document.getElementById('companyAbout')) {
  // SP時だけスライダーにする
  companyAboutSwiper = false
  if (window.matchMedia('(max-width:768px)').matches) {
    companyAboutSwiperInit()
  }
  window.addEventListener('resize', function (e) {
    if (companyAboutSwiper && window.matchMedia('(min-width:841px)').matches) {
      companyAboutSwiper.destroy()
      companyAboutSwiper = false
    } else if (!companyAboutSwiper && window.matchMedia('(max-width:840px)').matches) {
      companyAboutSwiperInit()
    }
  })
}
function companyAboutSwiperInit() {
  // Swiperコンテナを検出したら実行
  const slideItem = document.getElementById('companyAbout')
  // eslint-disable-next-line no-unused-vars
  companyAboutSwiper = new Swiper(slideItem, {
    effect: 'slide', // slide,fade,cube,coverflow
    speed: 500, // アニメ速度
    loop: true, // ループ
    autoplay: {
      // オートオプション
      delay: 5000, // 待機時間
      disableOnInteraction: false, // 操作されたらオート解除
    },
  })
}

/*
########  #######
   ##    ##     ##
   ##    ##     ##
   ##     #######
   ##    ##     ##
   ##    ##     ##
   ##     #######
*/
// TRUNK8
function trunk8() {
  $('.js-t8.line2').trunk8({
    // 指定要素に行数制限をかける
    lines: 2,
    fill: '...',
  })
  $('.js-t8.line1').trunk8({
    // 指定要素に行数制限をかける
    lines: 1,
    fill: '...',
  })
}
if ($('.js-t8')[0]) {
  // 要素を検出したら実行
  trunk8()
  $(window).on('load resize ', function () {
    trunk8()
  })
}

/* global AjaxZip3 */
if (document.getElementById('js-zip')) {
  document.getElementById('js-zip').addEventListener(
    'click',
    function () {
      AjaxZip3.zip2addr('郵便番号[data][0]', '郵便番号[data][1]', '住所', '住所')
    },
    false
  )
}

$('.js-product-spmenu').on('click tap', function () {
  $(this).toggleClass('open')
  $(this).next().slideToggle()
})

if ($('.js-product-s-spec')[0]) {
  const cnt = $('.js-product-s-spec tr:first').children().length
  const tr = $('.js-product-s-spec tr')
  for (let i = 0; i < tr.length; i++) {
    const td = tr.eq(i).children().first()
    td.addClass('product-s__specification__ttl')
    const rowspan = parseInt(td.attr('rowspan'))
    if (rowspan > 1) {
      i = i + rowspan - 1
    }
  }
}

/*
##     ##  #######  ########     ###    ##
###   ### ##     ## ##     ##   ## ##   ##
#### #### ##     ## ##     ##  ##   ##  ##
## ### ## ##     ## ##     ## ##     ## ##
##     ## ##     ## ##     ## ######### ##
##     ## ##     ## ##     ## ##     ## ##
##     ##  #######  ########  ##     ## ########
*/
const modalOverlay = document.getElementById('modalOverlay') // モーダル用オーバーレイ
const modals = document.getElementsByClassName('js-modal') // モーダル本体
// const modalYoutube = document.getElementsByClassName('js-modal-youtube') // モーダル内YouTube
if (modals[0]) {
  window.addEventListener('click', (e) => {
    if (!e.target.closest('.js-modal-open')) {
      return
    }
    e.preventDefault()
    modalClose()
    const target = e.target.closest('.js-modal-open').dataset.modal
    modalOpen(target)
  })
  // モーダル撤去
  window.addEventListener('click', (e) => {
    if (!e.target.closest('.js-modal-close')) {
      return
    }
    e.preventDefault()
    modalClose()
  })
}

function modalOpen(target) {
  document.querySelector('.js-modal--' + target).classList.add('active')
  modalOverlay.classList.add('active')
  scrollLock('body', '#modalOverlay')

  document.getElementById('wrapper').classList.add('isModal')
}

function modalClose() {
  // モーダルを消す
  for (let index = 0; index < modals.length; index++) {
    const modal = modals[index]
    modal.classList.remove('active')
  }
  modalOverlay.classList.remove('active')
  scrollLock('body', '#modalOverlay')

  document.getElementById('wrapper').classList.remove('isModal')
}

/*
#### ##    ## ########  ##     ## ########
 ##  ###   ## ##     ## ##     ##    ##
 ##  ####  ## ##     ## ##     ##    ##
 ##  ## ## ## ########  ##     ##    ##
 ##  ##  #### ##        ##     ##    ##
 ##  ##   ### ##        ##     ##    ##
#### ##    ## ##         #######     ##
*/
/*
         ######  ##       ########    ###    ########
        ##    ## ##       ##         ## ##   ##     ##
        ##       ##       ##        ##   ##  ##     ##
####### ##       ##       ######   ##     ## ########
        ##       ##       ##       ######### ##   ##
        ##    ## ##       ##       ##     ## ##    ##
         ######  ######## ######## ##     ## ##     ##
*/
if (document.getElementsByClassName('js-inputClear')[0]) {
  window.addEventListener('click', (e) => {
    if (!e.target.closest('.js-inputClear')) {
      return
    }
    e.preventDefault()
    inputClear(e.target.dataset.clear)
  })
}

function inputClear(target) {
  const itemList = document.getElementsByClassName('js-inputGroup--' + target)
  for (let index = 0; index < itemList.length; index++) {
    if (itemList[index].type === 'checkbox') {
      itemList[index].checked = false
    } else {
      itemList[index].value = ''
    }
  }
}
/*
           ###    ########  ########  ##       ##    ##
          ## ##   ##     ## ##     ## ##        ##  ##
         ##   ##  ##     ## ##     ## ##         ####
####### ##     ## ########  ########  ##          ##
        ######### ##        ##        ##          ##
        ##     ## ##        ##        ##          ##
        ##     ## ##        ##        ########    ##
*/
if (document.getElementsByClassName('js-inputApply')[0]) {
  window.addEventListener('click', (e) => {
    if (!e.target.closest('.js-inputApply')) {
      return
    }
    e.preventDefault()
    inputApply(e.target.dataset.apply)
  })
}
function inputApply(target) {
  if (!checkValidate(target)) {
    return
  }
  // 基本のモーダルに戻る

  modalClose()
  modalOpen('ans')
  const itemList = document.getElementsByClassName('js-inputGroup--' + target)
  let applyCheck = ''
  let applyText = ''
  for (let index = 0; index < itemList.length; index++) {
    if (itemList[index].type === 'checkbox') {
      if (!itemList[index].checked) {
        continue
      }
      if (applyCheck !== '') {
        applyCheck += ','
      }
      applyCheck += itemList[index].value
    } else {
      applyText += itemList[index].value
    }
  }

  let applyView = '選択してください'
  if (applyCheck !== '') {
    applyView = applyCheck
  }
  document.querySelector('.js-inputApply-view--' + target).innerText = applyView
  document.querySelector('.js-inputApply-check--' + target).value = applyCheck
  document.querySelector('.js-inputApply-text--' + target).value = applyText

  hiddenValidate(target) // メインモーダルのバリデーションを再検証する

  inputClear(target)
}

/*
        ##     ##    ###    ##       ####
        ##     ##   ## ##   ##        ##
        ##     ##  ##   ##  ##        ##
####### ##     ## ##     ## ##        ##
         ##   ##  ######### ##        ##
          ## ##   ##     ## ##        ##
           ###    ##     ## ######## ####
*/

function checkValidate(target) {
  const itemList = document.getElementsByClassName('js-inputGroup--' + target)
  let isPass = false
  for (let index = 0; index < itemList.length; index++) {
    if (itemList[index].type === 'checkbox') {
      if (itemList[index].checked) {
        isPass = true
        break
      }
    }
  }
  if (isPass) {
    document.querySelector('.js-validateCheck--' + target).classList.remove('active')
    return true
  } else {
    document.querySelector('.js-validateCheck--' + target).classList.add('active')
    return false
  }
}
function hiddenValidate(target) {
  if (document.querySelector('.js-inputApply-check--' + target).value !== '') {
    document.querySelector('.js-validateHidden--' + target).classList.remove('active')
    return true
  } else {
    document.querySelector('.js-validateHidden--' + target).classList.add('active')
    return false
  }
}

/*
           ###    ##    ##  ######
          ## ##   ###   ## ##    ##
         ##   ##  ####  ## ##
####### ##     ## ## ## ##  ######
        ######### ##  ####       ##
        ##     ## ##   ### ##    ##
        ##     ## ##    ##  ######
*/
// 回答のモーダルを開き、前回の入力内容を再現する
function inputAns(target) {
  const nowCheck = document.querySelector('.js-inputApply-check--' + target).value.split(',')
  const nowText = document.querySelector('.js-inputApply-text--' + target).value

  const itemList = document.getElementsByClassName('js-inputGroup--' + target)
  for (let index = 0; index < itemList.length; index++) {
    if (itemList[index].type === 'checkbox') {
      if (nowCheck.indexOf(itemList[index].value) !== -1) {
        itemList[index].checked = true
      }
    } else {
      itemList[index].value = nowText
    }
  }

  modalClose()
  modalOpen(target)
}

window.addEventListener('click', (e) => {
  if (!e.target.closest('.js-ansOpen')) {
    return
  }
  e.preventDefault()
  modalClose()
  const target = e.target.closest('.js-ansOpen').dataset.modal
  inputAns(target)
})

/*
         ######  ######## ##    ## ########
        ##    ## ##       ###   ## ##     ##
        ##       ##       ####  ## ##     ##
#######  ######  ######   ## ## ## ##     ##
              ## ##       ##  #### ##     ##
        ##    ## ##       ##   ### ##     ##
         ######  ######## ##    ## ########
*/
function inputSend() {
  const productValidate = hiddenValidate('product')
  const storeValidate = hiddenValidate('store')
  if (!productValidate || !storeValidate) {
    return
  }
  ajaxAns()
  modalClose()

  // ファイルを開く
  window.open(document.querySelector('[name="url"]').value, '_blank')

  // 以降アンケートを飛ばすようにクラスを書き換える
  const modalBtn = document.getElementsByClassName('js-ansShift')
  for (let index = 0; index < modalBtn.length; index++) {
    const item = modalBtn[index]
    item.classList.add('js-urlOpen')
    item.classList.remove('js-modal-open')
    item.classList.remove('js-dataTrace')
  }
}

window.addEventListener('click', (e) => {
  if (!e.target.closest('.js-ansSend')) {
    return
  }
  e.preventDefault()
  inputSend()
})

/*
           ###          ##    ###    ##     ##
          ## ##         ##   ## ##    ##   ##
         ##   ##        ##  ##   ##    ## ##
####### ##     ##       ## ##     ##    ###
        ######### ##    ## #########   ## ##
        ##     ## ##    ## ##     ##  ##   ##
        ##     ##  ######  ##     ## ##     ##
*/
let ajax = false // Ajaxリクエスト
function ajaxAns() {
  if (ajax) {
    // 既に通信中なら切断
    ajax.abort()
  }

  const ajaxParam =
    'product=' +
    encodeURIComponent(document.querySelector('[name="product"]').value) +
    '&store=' +
    encodeURIComponent(document.querySelector('[name="store"]').value) +
    '&store-text=' +
    encodeURIComponent(document.querySelector('[name="store-text"]').value) +
    '&item-id=' +
    encodeURIComponent(document.querySelector('[name="id"]').value) +
    '&url=' +
    encodeURIComponent(document.querySelector('[name="url"]').value) +
    '&doc-name=' +
    encodeURIComponent(document.querySelector('[name="name"]').value)

  ajax = new XMLHttpRequest() // Ajaxリクエスト
  ajax.open('POST', './', true) // GET/POST, URL, 非同期処理
  ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest') // Ajaxでのアクセスと明示するリクエストヘッダー

  ajax.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded;charset=UTF-8') // POST時に必要なリクエストヘッダー
  ajax.responseType = 'text' // 取得タイプ
  ajax.timeout = 10000 // タイムアウト判定時間
  ajax.send(ajaxParam) // POSTリクエスト実行
  ajax.onload = function () {
    // アクセス成功
    if (ajax.status < 200 || ajax.status >= 400) {
      console.log('Error: Code ' + ajax.status) // エラー
      return
    }

    console.log(ajax.response) // 結果を取得

    ajax.ontimeout = function (e) {
      // タイムアウト
    }
    ajax.onerror = function () {
      // Ajax処理失敗
    }
    ajax.onloadend = function () {
      // 受信成否に関わらず実行
      ajax = false
    }
  }
}

/*
        ######## ########     ###     ######  ########
           ##    ##     ##   ## ##   ##    ## ##
           ##    ##     ##  ##   ##  ##       ##
#######    ##    ########  ##     ## ##       ######
           ##    ##   ##   ######### ##       ##
           ##    ##    ##  ##     ## ##    ## ##
           ##    ##     ## ##     ##  ######  ########
*/
window.addEventListener('click', (e) => {
  if (!e.target.closest('.js-dataTrace')) {
    return
  }
  e.preventDefault()
  document.querySelector('.js-dataTrace--url').value = e.target.dataset.url
  document.querySelector('.js-dataTrace--name').value = e.target.dataset.name
})

/*
         #######  ########  ######## ##    ##
        ##     ## ##     ## ##       ###   ##
        ##     ## ##     ## ##       ####  ##
####### ##     ## ########  ######   ## ## ##
        ##     ## ##        ##       ##  ####
        ##     ## ##        ##       ##   ###
         #######  ##        ######## ##    ##
*/
window.addEventListener('click', (e) => {
  if (!e.target.closest('.js-urlOpen')) {
    return
  }
  e.preventDefault()
  window.open(e.target.dataset.url, '_blank')
})

/*
#### ##    ## ####          ######   ######  ########
 ##  ###   ##  ##          ##    ## ##    ## ##     ##
 ##  ####  ##  ##          ##       ##       ##     ##
 ##  ## ## ##  ##  #######  ######  ##       ########
 ##  ##  ####  ##                ## ##       ##   ##
 ##  ##   ###  ##          ##    ## ##    ## ##    ##
#### ##    ## ####          ######   ######  ##     ##
*/
if (document.getElementById('js-initScroll')) {
  autoScroll('#js-initScroll', '#header', true)
}

/*
######## ########  ########   #######  ########
##       ##     ## ##     ## ##     ## ##     ##
##       ##     ## ##     ## ##     ## ##     ##
######   ########  ########  ##     ## ########
##       ##   ##   ##   ##   ##     ## ##   ##
##       ##    ##  ##    ##  ##     ## ##    ##
######## ##     ## ##     ##  #######  ##     ##
*/
const errorList = document.querySelectorAll('.mw_wp_form .error')

if (errorList[0]) {
  for (let index = 0; index < errorList.length; index++) {
    const jsonData = JSON.parse(errorList[index].innerText)

    const errorTarget = document.querySelectorAll('[name^="' + jsonData.name + '"]')
    console.log(errorTarget[0])
    for (let index = 0; index < errorTarget.length; index++) {
      const element = errorTarget[index]
      element.classList.add('isError')
      // element.classList.add('js-disError')

      // チェックボックスはラベルにクラスをつける
      if (element.type === 'checkbox') {
        element.closest('label').classList.add('isError')
        // element.closest('label').classList.add('js-disError')
      }
      if (jsonData.name === '個人情報') {
        element.closest('.contact-form__caution').classList.add('isError')
        // element.closest('.contact-form__caution').classList.add('js-disError')
      }

      // プレースホルダーを差し替える
      if (jsonData.placeholder) {
        element.placeholder = jsonData.placeholder
      }
    }
  }
}

/*
########   #######  ########           ######  ######## ##       ########  ######  ########
##     ## ##     ## ##     ##         ##    ## ##       ##       ##       ##    ##    ##
##     ## ##     ## ##     ##         ##       ##       ##       ##       ##          ##
########  ##     ## ########  #######  ######  ######   ##       ######   ##          ##
##        ##     ## ##                      ## ##       ##       ##       ##          ##
##        ##     ## ##                ##    ## ##       ##       ##       ##    ##    ##
##         #######  ##                 ######  ######## ######## ########  ######     ##
*/
window.addEventListener('click', function (e) {
  // 指定のクラスを持つ
  if (e.target.classList.contains('js-popSelect-open')) {
    if (e.target.dataset.popSelectOpen) {
      popSelectOpen(e.target.dataset.popSelectOpen)
    } else {
      popSelectOpen('close')
    }
  }
  if (e.target.classList.contains('js-popSelect-select')) {
    popSelectApply(e.target)
  }
})

function popSelectOpen(target) {
  const selectList = document.getElementsByClassName('js-popSelect')
  for (let index = 0; index < selectList.length; index++) {
    const select = selectList[index]

    if (select.classList.contains('js-popSelect--' + target)) {
      select.classList.add('active')
    } else {
      select.classList.remove('active')
    }
  }

  // SP幅で閉じる場合以外はスクロールを固定する
  if (target !== 'close') {
    document.getElementById('js-popSelect-bg').classList.add('active')
  } else {
    document.getElementById('js-popSelect-bg').classList.remove('active')
  }
  if (window.matchMedia('(max-width:840px)').matches) {
    scrollLock('body', '#js-popSelect-bg')
  }
}

function popSelectApply(item) {
  const viewList = document.getElementsByClassName('js-popSelect-view--' + item.dataset.popSelectView)
  const inputList = document.getElementsByClassName('js-popSelect-input--' + item.dataset.popSelectView)
  for (let index = 0; index < viewList.length; index++) {
    viewList[index].innerText = item.dataset.popSelectText
  }
  for (let index = 0; index < inputList.length; index++) {
    inputList[index].value = item.dataset.popSelectValue
  }

  document.querySelector('[name="' + item.dataset.popSelectInput + '"]').value = item.dataset.popSelectValue

  validateAllInput() // 入力欄が埋まったか確認する
}

function validateAllInput() {
  const validateList = document.getElementsByClassName('js-validateAllInput')
  let collect = true
  for (let index = 0; index < validateList.length; index++) {
    if (validateList[index].value === '') {
      collect = false
      break
    }
  }
  const validateSubmit = document.getElementsByClassName('js-validateAllInput-submit')
  if (collect) {
    for (let index = 0; index < validateSubmit.length; index++) {
      validateSubmit[index].classList.remove('disable')
    }
  } else {
    for (let index = 0; index < validateSubmit.length; index++) {
      validateSubmit[index].classList.add('disable')
    }
  }
}
